import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgClock = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	style: { color: "#005AA0" },
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M14.3046 11.668L11 9.46482V5H9V10.5352L13.1952 13.332L14.3046 11.668Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M1 10C1 5.03872 5.03872 1 10 1C14.9613 1 19 5.03872 19 10C19 14.9613 14.9613 19 10 19C5.03872 19 1 14.9613 1 10ZM17 10C17 6.12667 13.8733 3 10 3C6.12667 3 3 6.12667 3 10C3 13.8733 6.12667 17 10 17C13.8733 17 17 13.8733 17 10Z",
			fill: "currentColor"
		})
	]
});
const ForwardRef = forwardRef(SvgClock);
export { ForwardRef as ReactComponent };
